import styled from "styled-components";

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  ${(props) => {
    switch (props.status) {
      case "planned":
        return `
          background: rgba(100, 116, 139, 0.12);
          color: #64748b;
        `;
      case "in-progress":
        return `
          background: rgba(40, 108, 165, 0.12);
          color: #286CA5;
        `;
      case "review":
        return `
          background: rgba(209, 180, 95, 0.22);
          color: #8b6a1a;
        `;
      case "completed":
        return `
          background: rgba(27, 231, 8, 0.12);
          color: #1be708;
        `;
      default:
        return `
          background: #f8f9fa;
          color: #6c757d;
        `;
    }
  }}
`;

export const PriorityBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  ${(props) => {
    switch (props.priority) {
      case "high":
        return `
          background: rgba(205, 61, 100, 0.12);
          color: #cd3d64;
        `;
      case "medium":
        return `
          background: rgba(255, 204, 0, 0.12);
          color: #cc9900;
        `;
      case "low":
        return `
          background: rgba(108, 117, 125, 0.12);
          color: #6c757d;
        `;
      default:
        return `
          background: #f8f9fa;
          color: #6c757d;
        `;
    }
  }}
`;
